module.exports = __webpack_public_path__ + "static/media/CareGiversGuidePageKK.050374af.pdf";